import posthog from 'posthog-js'
import { isPosthogEnabled } from '../config/features'

if (isPosthogEnabled()) {
  posthog.init(process.env.REACT_APP_POSTHOG_API_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    persistence: 'localStorage',
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    enable_recording_console_log: true,
  })
}

export const posthogIdentify = (user) => {
  if (isPosthogEnabled()) {
    posthog.identify(user.uid, {
      company: user.company,
      companyUid: user.companyUid,
      email: user.email,
      name: user.firstName + ' ' + user.lastName,
      phone: user.phone,
      properties: user.properties,
      // `role` is the effective role every permission check uses; `accountRole`
      // and `roles` are the raw DB values. Reporting all three is what makes a
      // Kinde/DB role drift visible here instead of only in a code trace — the
      // gap that made "Assign Driver is missing" hard to diagnose.
      role: user.role,
      accountRole: user.accountRole,
      roles: user.roles,
      uid: user.uid,
      username: user.username,
    })
  }
}

export const posthogCapture = (event, properties) => {
  if (isPosthogEnabled()) {
    posthog.capture(event, properties)
  }
}

export default posthog
